import { 
  WifiIcon, 
  ExclamationTriangleIcon,
  XMarkIcon 
} from '@heroicons/react/24/outline';
import React from 'react';

import { useConnectionStatus } from '../../hooks/useServiceWorker';

/**
 * Componente para mostrar el estado de conexión
 */
const ConnectionStatus: React.FC = () => {
  const { isOnline, showNotification, hideNotification } = useConnectionStatus();

  if (!showNotification) {
    return null;
  }

  return (
    <div className={`fixed top-4 right-4 z-50 max-w-sm w-full transition-all duration-300 ${
      isOnline ? 'animate-slide-in-right' : 'animate-bounce'
    }`}>
      <div className={`rounded-lg shadow-lg p-4 ${
        isOnline 
          ? 'bg-green-50 border border-green-200' 
          : 'bg-red-50 border border-red-200'
      }`}>
        <div className="flex items-start">
          <div className="flex-shrink-0">
            {isOnline ? (
              <WifiIcon className="h-5 w-5 text-green-400" />
            ) : (
              <ExclamationTriangleIcon className="h-5 w-5 text-red-400" />
            )}
          </div>
          
          <div className="ml-3 flex-1">
            <h3 className={`text-sm font-medium ${
              isOnline ? 'text-green-800' : 'text-red-800'
            }`}>
              {isOnline ? 'Conexión Restaurada' : 'Sin Conexión'}
            </h3>
            
            <p className={`mt-1 text-sm ${
              isOnline ? 'text-green-700' : 'text-red-700'
            }`}>
              {isOnline 
                ? 'La aplicación está sincronizada y funcionando normalmente.'
                : 'Trabajando en modo offline. Algunas funciones pueden no estar disponibles.'
              }
            </p>
            
            {!isOnline && (
              <div className="mt-2">
                <p className="text-xs text-red-600">
                  <span role="img" aria-label="Consejo">💡</span> <strong>Tip:</strong> Los datos de emergencia pueden estar disponibles localmente.
                </p>
              </div>
            )}
          </div>
          
          <div className="ml-4 flex-shrink-0">
            <button
              onClick={hideNotification}
              className={`rounded-md inline-flex text-sm ${
                isOnline 
                  ? 'text-green-400 hover:text-green-500' 
                  : 'text-red-400 hover:text-red-500'
              }`}
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionStatus;
